<template>
  <div className="home-page">
    <Home />
  </div>
</template>
<script>
import "ol/ol.css";
import Home from "./../../components/Home";

export default {
  name: "HomePage",
  components: {
    Home
  }
};
</script> 